import AccountDisplay from "@core-components/accountDisplay/AccountDisplay";
import SSLoLGradientText from "@core-components/title/components/SSLoLGradientText";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import type { AppRegion } from "@core-types/region.enum";
import useAppTranslation from "@hooks/language/useAppTranslation";
import type ISkin from "@modules/skins/shared/models/ISkin.model";
import { Trans } from "react-i18next";
import SkinLinkCard from "../../shared/components/SkinLinkCard";

interface ISkinSearchPopularProps {
  loadData: (region: AppRegion) => void;
  popularSkins: ISkin[];
}

export const SkinSearchPopular: React.FC<ISkinSearchPopularProps> = ({
  loadData,
  popularSkins,
}) => {
  const { t } = useAppTranslation("pages.skins.search");

  return (
    <AccountDisplay.Carousel
      emoji="Fire"
      onRegionChange={loadData}
      label={
        <Trans t={t} i18nKey={"popular.title"}>
          <SSWhiteText> SKINS </SSWhiteText>
          <SSLoLGradientText>POPULAIRES</SSLoLGradientText>
        </Trans>
      }
    >
      {popularSkins.map((skin) => (
        <SkinLinkCard
          key={skin.id}
          championSlug={skin.champion.slug}
          skin={skin}
        />
      ))}
    </AccountDisplay.Carousel>
  );
};
